module.exports = __webpack_public_path__ + "img/br.f66931e8.svg";